import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, withStyles, AppBar, Typography, Toolbar } from 'material-ui';
import CalendarHeaderStyles from './CalendarHeaderStyles';
import ArrowLeftIcon from '../../../icons/ArrowLeftIcon';
import Dictionary from '../../../model/Dictionary';
import Constants from '../../../model/AppConfiguration';

const CalendarHeader = ({ selectedTrip, handleClose, classes }) => (
  <AppBar
    position='static'
    style={{ width: '100%', backgroundColor: 'transparent', color: 'rgba(0, 0, 0, 0.54)' }}
  >
    <Toolbar>
      <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
        <ArrowLeftIcon className='navbar-arrow-icon' color='rgba(0, 0, 0, 0.54)' />
      </IconButton>
      <Typography type='title' color='inherit' className={classes.flex}>
        {Constants.flights.oneWay === selectedTrip.id ?
          Dictionary.flights.dateSelection :
          Dictionary.flights.datesSelection}
      </Typography>
    </Toolbar>
  </AppBar>
);

CalendarHeader.propTypes = {
  selectedTrip: PropTypes.object,
  handleClose: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(CalendarHeaderStyles)(CalendarHeader);



// WEBPACK FOOTER //
// ./src/components/flights/calendarMobile/CalendarHeader.js